import { useState, useTransition } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "~/components/Button";
import { Input } from "~/components/input";

export function AttachSlackChannelForm({
  onSuccess,
}: {
  onSuccess?: () => void;
}) {
  const navigate = useNavigate();
  const [isPending, startTransition] = useTransition();
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // @ts-expect-error not sure why this is a type error; should be fine
    startTransition(async () => {
      const formData = new FormData(e.currentTarget);
      const customerId = formData.get("customer_id");
      const slackChannel = formData.get("slack_channel");

      try {
        const response = await fetch(
          `/api/customers/${customerId}/slack-channel`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              slack_channel: slackChannel,
            }),
          },
        );

        if (response.ok) {
          const data = await response.json();
          if (onSuccess) {
            onSuccess();
          }
          navigate("/", {
            state: {
              flash:
                data.message ||
                "Successfully attached Slack channel to customer",
            },
          });
        } else {
          const errorData = await response.json();
          setError(
            errorData.error ||
              errorData.message ||
              "Failed to attach Slack channel",
          );
        }
      } catch (error) {
        console.error("Error:", error);
        setError("An error occurred while processing your request");
      }
    });
  };

  return (
    <form method="post" className="space-y-4" onSubmit={handleSubmit}>
      {error ? <p className="text-red-500">{error}</p> : null}
      <Input
        type="text"
        name="customer_id"
        className="w-full"
        disabled={isPending}
        placeholder="Enter customer ID"
        required
      />
      <Input
        type="text"
        name="slack_channel"
        className="w-full"
        disabled={isPending}
        placeholder="Slack channel ID or link (e.g., C0123456789)"
        required
      />
      <div className="flex justify-end gap-2">
        <Button
          className="rounded bg-gray-100 px-4 py-2 text-sm hover:bg-gray-200"
          type="submit"
          disabled={isPending}
        >
          {isPending ? "Attaching..." : "Attach Slack Channel"}
        </Button>
      </div>
    </form>
  );
}
